// extracted by mini-css-extract-plugin
export default {"tabs":"Tabs_tabs__nNAG1","tabButton":"Tabs_tabButton__R9h6p","tabButtonActive":"Tabs_tabButtonActive__R28UW"};